import React from 'react'

import AlumniMeet from '../components/alumni/alumniMeet'
import AlumniHighlight from '../components/alumni/alumniHighlight'
import AlumniSpeak from '../components/alumni/alumniSpeak'
import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'
import AlumnicCta from '../components/alumni/alumnicta'


const AlumniPage = () => {
    return (
        <>
            <Navbar />
            <AlumniMeet />
            <AlumnicCta />
            <AlumniSpeak />
            <AlumniHighlight />
            <Footer />
        </>
    )
}

export default AlumniPage